import * as angular from 'angular';

import { ComponentDefinition } from '../../models';
import { IStoreService } from '../../services';

class AlarmsManagementStateController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;

    static $inject = [
        'storeService'
    ];

    constructor(
        private _storeService: IStoreService
    ) {
    }

    onUpdate() {
        this._storeService.dispatchers().alarms.getAll(true);
        this._storeService.dispatchers().groups.getAll(true);
        this._storeService.dispatchers().valueViewModels.getAll(true);
    }
}

export const wtAlarmsManagementState: ComponentDefinition = {
    componentId: 'wtAlarmsManagementState',
    controller: AlarmsManagementStateController,
    template: require('./alarmsManagementState.component.html'),
    controllerAs: 'vm',
    bindings: {}
};